// extracted by mini-css-extract-plugin
export default {"style":"main-module__style__zV7+V","mainContent":"main-module__mainContent__rzcyw","backgroundImage":"main-module__backgroundImage__ai6ZG"};